<template>
  <div class="company-order-incomes">
    <div class="row">
      <form class="col-12 d-flex justify-content-center">
        <div class="input-group mx-2 col-4">
          <div class="input-group-prepend">
            <button class="btn btn-primary" type="button">开始</button>
          </div>
          <input title="开始时间" min="2018-02-01" max="2030-01-01" class="form-control" type="date" v-model="begin">
        </div>

        <div class="input-group mx-2 col-4">
          <div class="input-group-prepend">
            <button class="btn btn-primary" type="button">结束</button>
          </div>
          <input title="结束时间" min="2018-02-01" max="2030-01-01" class="form-control" type="date" v-model="end">
        </div>
        <button-group :p-button-group="buttonGroup" size="md"></button-group>
        <button class="btn btn-primary mx-2" v-on:click.prevent="exportData">按照订单创建时间导出</button>
      </form>

      <form id='export-spreadsheet-form' enctype='multipart/form-data' method='post' action='/api/order_incomes/spreadsheet'>
        <input type='hidden' name='name'>
        <input type='hidden' name='begin'>
        <input type='hidden' name='end'>
        <input type='hidden' name='company_code'>
      </form>
    </div>

    <pager v-bind:items='this.incomes || []' :count="this.income_count"></pager>
    
    <div class="">
      <table class="table table-sm">
        <thead>
          <tr>
            <th>公司</th>
            <th>订单</th>
            <th>金额</th>
            <th>时间</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="income in incomes">
            <td>{{income.company.nickname}}</td>
            <td>
              <router-link :to="'/orders/' + income.order_no">{{ income.order_no }}</router-link><br/>
              {{income.order.company_order_no}}
            </td>
            <td>{{income.amount}}元</td>
            <td><local-time :time="income.created_at"></local-time></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import LocalTime from '@/components/_small/LocalTime'
import LoadDataMixin from '@/mixins/load_data'
import OrderMixin from '@/mixins/order'
import ButtonGroup from '@/components/_partial/ButtonGroup'
import Pager from './_partial/Pager'
import dayjs from 'dayjs'

function loadData () {
  this.$http.doSpin()
  this.$http.get('/api/order_incomes' + location.search).then(response => {
    this.$http.cancelSpin()
    this.income_count = response.data.count
    this.incomes = response.data.data
  })
}

function exportData () {
  let form = document.getElementById('export-spreadsheet-form')
  form.querySelector('input[name="begin"]').setAttribute('value', this.begin)
  form.querySelector('input[name="end"]').setAttribute('value', this.end)
  form.querySelector('input[name="company_code"]').setAttribute('value', this.$route.query.company_code || '')
  form.submit()
}

export default {
  name: 'company-order-incomes',
  data () {
    return {
      income_count: 0,
      begin: '',
      end: '',
      incomes: []
    }
  },
  methods: {
    loadData,
    exportData
  },
  mixins: [
    OrderMixin, LoadDataMixin
  ],
  components: {
    LocalTime,
    Pager,
    ButtonGroup
  },
  computed: {
    buttonGroup () { return this.computeCompanyButtonGroup() }
  },
  mounted () {
    this.loadData()
  },
  created () {
    if (!this.begin || !this.end) {
      this.end = dayjs().format('YYYY-MM-DD')
      this.begin = dayjs(new Date().setDate(1)).format('YYYY-MM-DD')
    }
  }
}
</script>
